<template>
    <div class="IndustryNews">
        <mediaCenter tabIndex="6"></mediaCenter>
        <div :class="isMobile?'':'industryBox'">
            <div :class="isMobile?'industryItem':'industryList clearfix'" v-for="(item,index) in noticeList" :key="index">
                <template v-if="!isMobile">
                    <p class="fl overh2" @click="jumpToDetails(item.id)">{{item.title}}</p>
                    <span class="fr time">{{item.addtime}}</span>
                </template>
                <template v-if="isMobile">
                    <p class="overh2" @click="jumpToDetails(item.id)">{{item.title}}</p>
                    <p class="textr c99 mt5">{{item.addtime}}</p>
                </template>
            </div>
            <div class="" v-if="!loading && noticeList.length==0">
                <el-empty description="暂无数据"></el-empty>
            </div>
            <el-pagination class="pageBox" v-if="noticeList.length!=0" background @current-change="handleCurrentChange" :current-page.sync="currentPage" :layout="isMobile?'prev, pager, next':'prev, pager, next, jumper'" :pager-count="isMobile?'5':'7'" :total="total"></el-pagination>
        </div>
    </div>
</template>

<script>
import mediaCenter from '@/components/mediaCenter'
const NEW_API_BASE = process.env.VUE_APP_NEW_API_URL || '/prod-api'
const newApi = (path) => NEW_API_BASE + path
	export default {
		name:'IndustryNews',
        components: {
            mediaCenter
        },
        data() {
            return {
                noticeList: [],
                loading: true,
                currentPage:1,
                pageindex:1,
                total:0
            }
        },
        mounted(){
            this.getNotice()
        },
        methods: {
             //获取公众参与公示
             getNotice(){
                this.loading = true
                this.Request({
                    url: newApi('/hzfglSys/news/public/noticeList'),
                    baseURL: '',
                    method: 'get',
                    data:{
                        pageindex:this.pageindex,
                        pagesize:10,
                        webcode:'web_100145'
                    }
                }).then((res) => {
                    var data = res.data;
                    if(data && data.rows && data.rows.length > 0){
                        this.noticeList = data.rows
                        this.total = data.total
                    }
                }).finally(() => {
                    this.loading = false
                })
            },
            jumpToDetails(id) {
                // this.$router.push({
                //     path: '/mediaCenter/NoticeDetails?id='+id,
                // })
                window.location.assign('/mediaCenter/NoticePubDetails?id='+id)
            },
            handleCurrentChange(val){
                this.currentPage = val
                this.pageindex=val
                this.getNotice()
            }

        }
	}
</script>

<style scoped>
    .industryBox{
        width: 1200px;
        margin: 0 auto;
        margin-top: 17px;
    }
    .industryList{
        padding: 32px 0;
        border-bottom: 1px solid #E1E1E1;
    }
    .industryList p{
        max-width: 90%;
        cursor: pointer;
    }
    .industryItem{
        padding: 15px 10px;
        border-bottom: 1px solid #E1E1E1;
    }
    .pageBox{
        text-align: center;
        margin-top: 35px;
        margin-bottom: 42px;
    }
</style>